<template>
  <div>
    <v-data-table
      :headers="[...headers, { value: 'actions', width: '56px' }]"
      :items="selectedItems"
      class="elevation-0"
      disable-sort
      hide-default-footer
      disable-pagination
      :items-per-page="-1"
    >
      <template v-for="slot in tableSlots" #[`item.${slot}`]="{ item, index }">
        <slot :name="`item.${slot}`" v-bind="{ item, index, items: selectableItems(item) }" />
      </template>
      <template #[`item.actions`]="{ index }">
        <v-btn
          fab
          small
          depressed
          color="primary"
          class="rounded-sm"
          @click="removeItem(index)"
          title="Eltávolítás"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>

      <template #footer>
        <v-divider />
        <div class="d-flex justify-center py-4">
          <v-btn
            color="primary"
            depressed
            :disabled="uniqueValues && selectedItems.length === items.length"
            @click="addItem"
          >
            <v-icon>mdi-plus</v-icon>
            Hozzáadás
          </v-btn>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    headers: {
      type: Array,
      default: () => [],
    },
    items: {
      type: [Array, Boolean],
      default: false,
    },
    value: {
      type: Array,
      default: () => [],
    },
    itemValue: {
      type: String,
      default: 'id',
    },
    itemText: {
      type: String,
      default: 'text',
    },
    uniqueValues: {
      type: Boolean,
      default: false,
    },
    hideDefaultHeader: {
      type: Boolean,
      default: false,
    },
    blankItemTemplate: {
      type: [Object, Boolean],
      default: () => ({}),
    },
  },

  data() {
    return {
      selectedItems: [],
    };
  },

  watch: {
    value: {
      handler() {
        this.selectedItems = this.value;
      },
      immediate: true,
      deep: true,
    },

    selectedItems: {
      handler(newValue) {
        this.$emit('input', newValue);
      },
      deep: true,
    },
  },

  methods: {
    addItem() {
      this.selectedItems.push(structuredClone(this.blankItemTemplate));
    },

    removeItem(index) {
      this.selectedItems.splice(index, 1);
    },

    selectableItems(item = {}) {
      if (!this.uniqueValues) {
        return this.items;
      }

      const items = [];
      if (Object.keys(item).length && item[this.itemValue]) {
        const result = this.items.find((e) => e[this.itemValue] == item[this.itemValue]);
        if (result) {
          item[this.itemText] = result[this.itemText]; // update its text
          items.push(item);
        }
      }
      for (const item of this.items) {
        if (this.selectedItems.find((e) => e[this.itemValue] == item[this.itemValue])) {
          continue;
        }
        items.push(item);
      }
      return items;
    },
  },

  computed: {
    tableSlots() {
      return this.headers
        .filter((header) => !!this.$scopedSlots[`item.${header.value}`])
        .map((e) => e.value);
    },
  },
};
</script>

<style lang="scss">
.v-data-table td {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
  border-bottom: none !important;
  &:first-of-type {
    padding-right: 0 !important;
  }
  &:last-of-type:not(:nth-of-type(2)) {
    padding-left: 0 !important;
  }
}
</style>
